<template>
    <div class="prices">
        <div class="prices__container container">
            <div class="prices__title">
                СТОИМОСТЬ
            </div>
            <div class="prices__select">
                <div :class="[
                    'prices__select-item',
                    {'__active': mode === 1}
                ]"
                     @click="switchMode(1)">
                    Аренда кортов
                </div>
                <div  :class="[
                    'prices__select-item',
                    {'__active': mode === 2}
                ]"
                      @click="switchMode(2)">
                    Групповые тренировки
                </div>
            </div>
            <div class="prices__tables" v-show="mode === 1">
                <div class="prices__tables-table">
                    <div class="prices__tables-table-header">
                        Будние дни
                    </div>
                    <div class="prices__tables-table-body">
                        <div class="prices__tables-table-row __headers">
                            <span class="prices__tables-table-col">
                                Время
                            </span>
                            <span class="prices__tables-table-col">
                                Цена за час
                            </span>
                        </div>
                        <div class="prices__tables-table-row"
                             v-for="price in listFormatted(courts, 'weekday')"
                             :key="price.time"
                        >
                            <span class="prices__tables-table-col">
                                {{ price.time_range }}
                            </span>
                            <span class="prices__tables-table-col">
                                {{ price.price_per_hour }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="prices__tables-table">
                    <div class="prices__tables-table-header">
                        Выходные
                    </div>
                    <div class="prices__tables-table-body">
                        <div class="prices__tables-table-row __headers">
                            <span class="prices__tables-table-col">
                                Время
                            </span>
                            <span class="prices__tables-table-col">
                                Цена за час
                            </span>
                        </div>
                        <div class="prices__tables-table-row"
                             v-for="price in listFormatted(courts, 'weekend')"
                             :key="price.time_range"
                        >
                            <span class="prices__tables-table-col">
                                {{ price.time_range }}
                            </span>
                            <span class="prices__tables-table-col">
                                {{ price.price_per_hour }}
                            </span>
                        </div>
                    </div>
                </div>
                <ul class="prices__tables-bonuses">
                    <li class="prices__tables-bonuses-item">
                        Аренда от 2х часов
                    </li>
                    <li class="prices__tables-bonuses-item">
                        Максимальное кол-во на 1 корт - 12 человек
                    </li>
                    <li class="prices__tables-bonuses-item">
                        Аренда мяча 100 рублей/час
                    </li>
                </ul>
            </div>
            <div class="prices__tables" v-show="mode === 2">
                <div class="prices__tables-table __large">
                    <div class="prices__tables-table-body">
                        <div class="prices__tables-table-row __headers">
                            <span class="prices__tables-table-col">
                                Кол-во занятий
                            </span>
                            <span class="prices__tables-table-col">
                                Start
                            </span>
                            <span class="prices__tables-table-col">
                                Start+ / Medium
                            </span>
                        </div>
                        <div class="prices__tables-table-row"
                             v-for="price in groups"
                             :key="price.price"
                        >
                            <span class="prices__tables-table-col">
                                {{ price.title }}
                            </span>
                            <span class="prices__tables-table-col">
                                {{ price.price }}
                            </span>
                            <span class="prices__tables-table-col">
                                {{ price.price_per_training }}
                            </span>
                        </div>
                    </div>
                </div>
                <ul class="prices__tables-bonuses __large">
                    <li class="prices__tables-bonuses-item">
                        Максимальное кол-во в группе: для Start – 10 человек, Start+/Medium – 8 человек
                    </li>
                    <li class="prices__tables-bonuses-item">
                        Длительность занятия: для Start – 1 час, Start+/Medium – 1,5 часа
                    </li>
                    <li class="prices__tables-bonuses-item">
                        Абонемент действителен 30 дней
                    </li>
                </ul>
            </div>
            <btn
                v-show="mode === 1"
                class="prices__btn ms_booking"
                :text="mode === 1 ? 'Арендовать корт' : 'Записаться на тренировку'"
                data-url="https://n1079742.yclients.com/company/888903/personal/select-services"
                mode="red"
            />
            <btn
                v-show="mode === 2"
                class="prices__btn ms_booking"
                data-url="https://n1079742.yclients.com/company/888903/activity/select"
                :text="'Записаться на тренировку'"
                mode="red"
            />
        </div>
    </div>
</template>

<script>

import Btn from "@/components/blocks/Btn";
export default  {
    name: "FourthBlockPrices",
    components: {Btn},
    props: {
        courts: {
        },
        groups: {
        }
    },
    data() {
        return {
            mode: 1,
            prices: [
                {
                    time: '7:00 - 11:00',
                    price: '1 500',
                    pricePro: '1 275'
                },
                {
                    time: '11:00 - 17:00',
                    price: '1 200',
                    pricePro: '1 020'
                },
                {
                    time: '17:00 - 19:00',
                    price: '2 600',
                    pricePro: '2 210'
                },
                {
                    time: '19:00 - 23:00',
                    price: '3 000',
                    pricePro: '2 550'
                },
            ],
            pricesWeekends: [
                {
                    time: '7:00 - 11:00',
                    price: '1 500',
                    pricePro: '1 275'
                },
                {
                    time: '11:00 - 17:00',
                    price: '2 600',
                    pricePro: '1 020'
                },
                {
                    time: '17:00 - 23:00',
                    price: '2 000',
                    pricePro: '2 210'
                },
            ],
            pricesGroup: [
                {
                    total: 'Подробнее',
                    price: 400,
                    priceOne: 400,
                    pricePro: ''
                },
                {
                    total: 'Разовое',
                    price: '1 000',
                    priceOne: '1 000',
                    pricePro: ''
                },
                {
                    total: '4 занятия',
                    price: '3 600',
                    priceOne: 900,
                    pricePro: '3 240'
                },
                {
                    total: '8 занятий',
                    price: '6 000',
                    priceOne: 750,
                    pricePro: '5 400'
                },
                {
                    total: '12 занятий',
                    price: '7 800',
                    priceOne: '650',
                    pricePro: '7 020'
                },
            ]
        }
    },
    methods: {
        switchMode(mode) {
            this.mode = mode;
        },
        getModal() {
            if (this.mode === 1) {
                this.emit('openPopup')
            }
        },
        listFormatted(list, key) {
            return list.filter(e => e.day_type === key)
        }
    }
}
</script>

<style lang="scss">
.prices {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 20px 0;
    background: url('@/assets/img/blackBg.png') center/cover no-repeat;
    background-position: 0 0;

    @include below($mobile) {
        margin: 10px 0;
    }

    &:before {
        position: absolute;
        content: '';
        bottom: -20px;
        width: 100%;
        height: 20px;
        background: linear-gradient(90deg, #4961F9 0%, #FF4747 49.33%, #FFB72A 100.76%);

        @include below($mobile) {
            bottom: -10px;
            height: 10px;
        }
    }

    &__container {
        display: flex;
        flex-direction: column;
        padding: 120px;

        @include below($mobile) {
            padding: 80px 0;
        }
    }

    &__title {
        font-family: BOWLER, sans-serif;
        font-size: 48px;
        font-weight: 400;
        line-height: 48px;

        @include below($mobile) {
            font-family: BOWLER, sans-serif;
            font-size: 34px;
            line-height: 40px;
            text-align: center;
        }
    }

    &__select {
        display: flex;
        width: 100%;
        margin-top: 50px;

        @include below($mobile) {
            flex-direction: column;
            margin-top: 30px;
        }

        &-item {
            font-family: BOWLER, sans-serif;
            font-size: 24px;
            font-weight: 400;
            color: #818181;
            cursor: pointer;
            transition: .2s ease-in-out;

            &:not(.__active):hover {
                color: #EEB546
            }

            @include below($mobile) {
                max-width: 100%;
                font-size: 20px;
            }

            &:not(:first-child) {
                margin-left: 50px;

                &:not(.__active):hover {
                    color: #1C43CE
                }

                @include below($mobile) {
                    margin-left: 0;
                    font-size: 20px;
                }

                &.__active {
                    color: #1C43CE
                }
            }

            &.__active {
                color: #EEB546
            }
        }
    }

    &__tables {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-top: 40px;
        color: #000000;

        @include below($mobile) {
            flex-direction: column;
            margin-top: 0;
        }

        @keyframes easeOpacity {
            0% {
                transform: scaleX(0);
                opacity: 0;
            }
            76% {
                opacity: .6;
            }
            100% {
                transform: scaleX(1);
                opacity: 1;
            }
        }

        &-table {
            display: flex;
            flex-direction: column;
            width: calc(50% - 30px);
            padding: 25px 40px 40px;
            background: #FCF2D3;
            border-radius: 20px;
            overflow: hidden;
            animation: easeOpacity .58s ease-in-out;
            transform-origin: top left;

            @include below($mobile) {
                width: 100%;
                padding: 25px 12px 40px;
                margin-top: 30px;
            }
            //custom value

            @include below(1100px) {
              width: 100%;
              padding: 25px 12px 40px;
              margin-top: 30px;
            }

            &.__large {
                width: calc(70% - 20px);

                @include below($mobile) {
                    width: 100%;
                }
                //custom value
                @include below(1200px) {
                  width: 100%;
                }

                .prices__tables-table-row {
                    grid-template-columns: 1fr 1fr 1fr;

                    @include below($mobile) {
                        grid-template-columns: 1fr 1fr 1fr;
                    }

                    @include below(425px) {
                        grid-template-columns: 1fr 1fr 1fr;
                    }

                    @include below($mobileS) {
                        grid-template-columns: 1fr 1fr 1fr;
                    }
                }
            }

            &-body {
                border: 1px solid #FCF2D3;
            }

            &-header {
                padding-left: 10px;
                font-family: BOWLER, sans-serif;
                font-size: 22px;
                font-weight: 400;
            }

            &-row {
                display: grid;
                grid-template-columns: 135px 1fr;
                font-family: Montserrat, sans-serif;
                font-size: 16px;
                font-weight: 600;
                line-height: 24px;
                text-align: left;

                @include below($mobile) {
                    grid-template-columns: 105px 1fr;
                    font-size: 12px;
                    line-height: 12px;
                }

                @include below($mobileS) {
                    font-size: 10px;
                    line-height: 10px;
                }

                &.__headers {
                    font-weight: 600;

                    .prices__tables-table-col {
                        color: #000 !important;
                    }

                }

                &:not(:last-child) {
                    border-bottom: 2px solid #fff;
                }
            }

            &-col {
                padding: 10px;

                @include below($mobile) {
                    padding: 10px 5px;
                }

                &:not(:last-child) {
                    border-right: 2px solid #fff;
                    border-right: 2px solid #fff;
                }

                &:not(:first-child) {
                    text-align: center;
                }
            }
        }

        &-bonuses {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin-top: 20px;
            padding: 0 30px;
            color: #fff;

            @include below($mobile) {
                flex-direction: column;
                align-items: center;
                padding: 0;
            }


            &.__large {
                display: flex;
                flex-direction: column;
                justify-content: center;
                width: calc(30% - 10px);
                padding: 0;
                color: #b3aaaa;

                @include below(1200px) {
                  flex-direction: row;
                  margin-left: 10px;
                  width: calc(100%);
                }

                @include below($mobile) {
                    align-items: flex-start;
                    margin-left: 10px;
                    width: calc(100%);
                }

                .prices__tables-bonuses-item {
                    margin: 20px 0;

                    @include below($mobile) {
                        font-size: 12px;
                        margin: 0 0 0 15px;
                    }
                }
            }

            &-item {
                position: relative;
                padding-left: 40px;

                @include below($mobile) {
                    padding: 5px 0;
                    font-size: 12px;
                }

                @include below($mobileS) {
                    font-size: 11px;
                }

                &:before {
                    position: absolute;
                    content: '';
                    width: 22px;
                    height: 16px;
                    left: 15px;
                    top: 11px;
                    transform: translateY(-50%);
                    background-repeat: no-repeat;
                    background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.782 12.246C14.712 11.9229 14.625 11.5942 14.5215 11.2638C14.2953 10.541 13.9975 9.83386 13.6363 9.16216C12.6704 7.36562 11.2846 5.86307 9.51553 4.69339C9.62242 4.49784 9.72677 4.31316 9.82415 4.14451C10.0839 3.69445 10.3485 3.27581 10.6127 2.89667C12.2068 3.95358 13.4776 5.29445 14.3915 6.88503C15.1615 8.22499 15.5137 9.45635 15.6742 10.2685C15.5896 10.5547 15.4886 10.8367 15.3714 11.1139C15.2044 11.5085 15.0075 11.8865 14.782 12.246ZM13.6566 13.6568C13.2344 14.079 12.7724 14.4489 12.2749 14.7637C12.2004 14.4016 12.0224 13.7523 11.5996 12.8235C11.2675 12.0943 10.8607 11.3473 10.3563 10.5403C9.76156 9.58089 9.20828 8.83392 8.71179 8.32018C8.49149 8.0923 8.32808 7.95924 8.22473 7.88533C8.23886 7.7598 8.28098 7.51597 8.40662 7.12903C8.62057 6.47029 8.96452 5.73627 9.30792 5.08078C11 6.20699 12.3259 7.64875 13.2509 9.36931C14.012 10.7849 14.3171 12.0668 14.4351 12.7544C14.1997 13.0723 13.94 13.3735 13.6566 13.6568ZM11.1134 15.3714C10.1272 15.7885 9.07947 16 7.99927 16C6.91909 16 5.87134 15.7885 4.88511 15.3714C4.17151 15.0696 3.51236 14.6702 2.91764 14.1799C3.67834 14.3701 4.649 14.5288 5.77366 14.5305C5.77992 14.5305 5.78594 14.5305 5.79219 14.5305C7.68259 14.5305 9.53238 14.0874 11.2941 13.2133C11.5647 13.8354 11.7104 14.3029 11.7863 14.5956C11.8332 14.7762 11.8594 14.9118 11.8739 15.0014C11.6279 15.1375 11.3744 15.261 11.1134 15.3714ZM2.20297 13.5145C1.69713 12.9834 1.27103 12.3926 0.930178 11.7505C1.66551 11.9852 2.79484 12.2564 4.16749 12.2951C4.28195 12.2983 4.39617 12.2999 4.51033 12.2999C6.4282 12.2999 8.3029 11.8439 10.0906 10.9423C10.4938 11.5988 10.8301 12.2147 11.1131 12.8147C9.4081 13.6631 7.61927 14.093 5.79217 14.093C5.78626 14.093 5.78025 14.093 5.77433 14.093C4.2283 14.0907 2.98626 13.7809 2.20297 13.5145ZM0.00492766 8.321C0.356607 8.43784 1.00761 8.60785 2.02064 8.70521C2.57468 8.75847 3.162 8.78483 3.80009 8.78483C4.06401 8.78483 4.33675 8.7803 4.61921 8.77133C5.74786 8.73556 6.67177 8.62967 7.36528 8.45668C7.67317 8.37987 7.87019 8.30487 7.98586 8.25252C8.07255 8.31638 8.22346 8.44083 8.4347 8.66355C8.73553 8.98074 9.22023 9.56404 9.85812 10.5694C8.04012 11.4795 6.131 11.9129 4.17985 11.8578C2.57224 11.8124 1.31401 11.437 0.662587 11.1961C0.650666 11.1688 0.638854 11.1414 0.627223 11.1139C0.25154 10.2258 0.042737 9.2877 0.00492766 8.321ZM0.627223 4.88614C1.03018 3.93347 1.60709 3.07791 2.34193 2.34316C3.07678 1.60842 3.93242 1.03155 4.88511 0.628587C4.98717 0.585473 5.08992 0.544624 5.19325 0.505858C4.64719 1.06996 4.02341 1.83124 3.45941 2.80274C2.50618 4.44459 1.96047 6.27473 1.83578 8.246C1.1618 8.16965 0.684028 8.06195 0.392532 7.98134C0.214618 7.93207 0.0848218 7.88733 0 7.85508C0.0180894 6.82624 0.228776 5.82811 0.627223 4.88614ZM8.28433 0.00507164C7.71321 0.524517 6.91421 1.36632 6.1946 2.53464C5.12576 4.26987 4.5237 6.22184 4.40374 8.33965C3.62409 8.35877 2.92265 8.34192 2.27152 8.2883C2.39014 6.37971 2.91662 4.60907 3.83782 3.02238C4.61279 1.68759 5.5036 0.765898 6.12721 0.219733C6.73596 0.0737267 7.36193 0 7.99927 0C8.09456 0 8.18958 0.00172043 8.28433 0.00507164ZM11.7208 0.91589C11.4441 1.16117 10.9707 1.63985 10.3782 2.47051C10.0659 2.90464 9.75205 3.39419 9.44524 3.92577C8.73199 5.16076 8.23587 6.21396 7.97055 7.05603C7.84537 7.45374 7.8018 7.71397 7.78721 7.86205C7.68848 7.90517 7.50514 7.97355 7.20658 8.04511C6.78115 8.147 6.03297 8.27517 4.84295 8.32525C4.96397 6.29584 5.54347 4.42593 6.56717 2.76406C7.41039 1.39512 8.3645 0.493541 8.89921 0.0497255C9.66192 0.134775 10.4036 0.328423 11.1134 0.628587C11.3206 0.716172 11.523 0.812091 11.7208 0.91589ZM15.3714 4.88614C15.7885 5.87222 16 6.9199 16 8C16 8.44427 15.9641 8.88292 15.8929 9.31415C15.6777 8.56029 15.3304 7.64078 14.771 6.6671C13.8254 5.02136 12.5128 3.63431 10.8678 2.54098C11.2712 1.99518 11.6034 1.63532 11.819 1.42329C11.952 1.29241 12.0565 1.20202 12.1269 1.14477C12.681 1.47872 13.1928 1.87942 13.6566 2.34316C14.3914 3.07791 14.9684 3.93347 15.3714 4.88614Z' fill='%23FCF2D3'/%3E%3C/svg%3E%0A");

                    @include below($mobile) {
                        left: -26px;
                        top: 14px;
                    }
                }
            }
        }
    }

    &__btn.btn {
        margin: 30px auto 0;

        &:hover {
            background: #FFC83A !important;
        }

        @include below($mobile) {
            margin: 30px 20px 0;
            width: calc(100% - 40px);
        }
    }
}
</style>
